/* ===== Header sticky ===== */
(function () {
  window.addEventListener('scroll', function () {
    var header = document.querySelector('.site-header');
    if (!header) return; 
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollPosition > 300) {
      header.classList.add('sticky-main-header');
    } else {
      header.classList.remove('sticky-main-header');
    }
  }, { passive: true });
})();